<div class="modal-header p-5">
    <mat-icon class="clickable text-transparent">&nbsp;&nbsp;&nbsp;&nbsp;</mat-icon>
    <h3 class="modal-title">Email Log</h3>
    <mat-icon class="close clickable me-4" (click)="onClose()">close</mat-icon>
</div>

<div class="modal-body">
    <p><strong>Subject:</strong> {{ subject }}</p>
    <p><strong>To:</strong> {{ to }}</p>
    <div [innerHTML]="safeHtmlBody"></div>
</div>